<ag-grid-angular
  class="ag-theme-alpine ag-theme-lum"
  style="width: 100%"
  [rowSelection]="'multiple'"
  [checkboxSelection]="true"
  [columnDefs]="columnDefs"
  [gridOptions]="gridOptions"
  (gridReady)="onGridReady($event)"
  (cellValueChanged)="onCellValueChanged($event)"
  (selectionChanged)="onSelectionChanged()"
></ag-grid-angular>
